<div class="content app-container">
    <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
    >
        <ng-container matColumnDef="code">
            <th
                mat-header-cell
                *matHeaderCellDef
            >
                code
            </th>
            <td
                mat-cell
                *matCellDef="let element"
            >
                {{ element.code }}
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th
                mat-header-cell
                *matHeaderCellDef
            >
                name
            </th>
            <td
                mat-cell
                *matCellDef="let element"
            >
                {{ element.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="active">
            <th
                mat-header-cell
                *matHeaderCellDef
            >
                active
            </th>
            <td
                mat-cell
                *matCellDef="let element"
            >
                {{ element.active }}
            </td>
        </ng-container>

        <ng-container matColumnDef="settings">
            <th
                mat-header-cell
                *matHeaderCellDef
            >
                settings
            </th>
            <td
                mat-cell
                *matCellDef="let element"
            >
                <button
                    class="tdButtons"
                    [disabled]="element.active == 0"
                    mat-raised-button
                >
                    <a
                        [routerLink]="[
                            '/home/product_man_settings/',
                            element.code,
                            perms.clientUuid
                        ]"
                        >{{ element.settings }}</a
                    >
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="preview">
            <th
                mat-header-cell
                *matHeaderCellDef
            >
                preview
            </th>
            <td
                mat-cell
                *matCellDef="let element"
            >
                <button
                    class="tdButtons"
                    [disabled]="element.active == 0"
                    mat-raised-button
                >
                    <a
                        [routerLink]="[
                            '/home/product_man_preview/',
                            element.code,
                            perms.clientUuid
                        ]"
                        >{{ element.preview }}</a
                    >
                </button>
            </td>
        </ng-container>

        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
        ></tr>
    </table>
</div>
